window.goals_storage = (function() {
    "use strict";
    var storage = {};
    try {
        document.cookie = 'test=1';
        storage.get = get_cookie;
        storage.set = set_cookie;
    } catch (e) {
        storage.get = get_storage;
        storage.set = set_storage;
    }
    function all_cookies() {
        var arr = document.cookie.split(";");
        var all = {};
        Array.prototype.forEach.call(arr, function(cookie) {
            cookie = cookie.replace(/(^\s+|\s+$)/gm, '').split('=');
            var name = decodeURIComponent(cookie[0]),
                value = decodeURIComponent(cookie.slice(1).join('='));
            all[name] = value;
        });
        return all;
    }
    function set_cookie(key, value, expires) {
        var cookie = key + '=' + encodeURIComponent(value) + ';';
        var date = new Date();
        date.setTime(date.getTime() + (expires * 24 * 3600 * 1000));
        cookie += 'expires=' + date.toUTCString() + ';';
        cookie += 'path=/;';
        document.cookie = cookie;
    }
    function get_cookie(key) {
        return all_cookies()[key] || '';
    }
    function get_storage(key) {
        var expires = localStorage.getItem(key+'-expires'), value;
        if (expires && expires < (new Date()) / 1000) {
            localStorage.removeItem(key);
            return false;
        }
        value = localStorage.getItem(key);
        return value;
    }
    function set_storage(key, value, expires) {
        var now = (new Date()) / 1000;
        localStorage.setItem(key, value);
        localStorage.setItem(key + '-expires', (now + expires * 24 * 3600 * 1000).toString());
    }
    return storage;
})();
window.register_goal = (function () {
    "use strict";
    var yaCounter = false,
        yaCounterVar = false,
        ym = window.ym;
    function translit(str) {
        var tr = 'аaбbвvгgдdеeёeжjзzиiйiкkлlмmнnоoпpрrсsтtуuфfхhцcчcшsщcь%ъ%ыyэeюuяy',
            trans = '';
        for (var i = 0; i < str.length; ++i) {
            var chr = str[i].toLowerCase(), idx;
            if (chr.match(/[a-z0-9\-_.]/)) {
                trans += chr;
                continue;
            }
            idx = tr.indexOf(chr);
            if (~idx && idx % 2 === 0) {
                trans += tr[idx + 1];
            }
        }
        return trans;
    }
    function get_event_key(goal) {
        return translit(goal.action);
    }
    function ya_goal(goal) {
        if (yaCounter === false && yaCounterVar === false) {
            for (var varName in window) {
                if (('' + varName).indexOf('yaCounter')>-1) {
                    yaCounter = parseInt(varName.replace('yaCounter', ''));
                    yaCounterVar = window[varName];
                    break;
                }
            }
        }
        if (yaCounter && ym) {
            console.log('ym(', yaCounter, 'reachGoal', goal.action);
            ym(yaCounter, 'reachGoal', goal.action);
        } else if (yaCounterVar && yaCounterVar.reachGoal) {
            console.log('yaCounterVar.reachGoal', goal.action);
            yaCounterVar.reachGoal(goal.action);
        } else {
            console.log('no yandex metrika');
        }
    }
    return function reg_func(goal) {
        //console.log('goal', goal);
        var event_key = get_event_key(goal), storage = window.goals_storage;
        //console.log('goal', goal);
        if (storage.get(event_key)) {
            console.log('goal was already registered', goal);
            return false;
        }
        ya_goal(goal);
        if (window.gtag) {
			var action = goal.action;
			//console.log('gtag', action);
            window.gtag('event', action);
            window.gtag('event', goal.action, {
                'send_to': 'UA-199384283-1',
                'event_category': goal.category,
                'event_action': goal.action,
                'event_label': goal.action,
                'value': goal.value || 1,
            });
        }
        if (window.fbq) {
            window.fbq('trackCustom', goal.action);
        }
        storage.set(event_key, '1');
    };
})();
function goal_reached(goal) {
    document.dispatchEvent(new CustomEvent("goal-reached", {detail: {goal:goal}}));
}
document.addEventListener("goal-reached", function(event) {
    var goal = event.detail.goal;
    window.register_goal(goal);
});
document.addEventListener("form-packing", function(event) {
	window.register_goal({category:"activity",action:"Заявка на упаковку"});
});
document.addEventListener("form-marketing", function(event) {
	window.register_goal({category:"activity",action:"Заявка на маркетинг"});
});
document.addEventListener("form-order", function(event) {
	window.register_goal({category:"activity",action:"Заявка любая"});
});

if (document.readyState === "complete" || document.readyState === "loaded") {
    goalsInit()
} else {
    document.addEventListener('DOMContentLoaded', goalsInit)
}
function goalsInit() {
    //console.log('document.location.href', document.location.href);
    if (~['https://ddma.me/brief-marketing', 'https://ddma.me/brief-package'].indexOf(document.location.href)) {
        window.register_goal({category: "activity", action: "Переход на бриф"});
    }
    window.setTimeout(function () {
        goal_reached({category: "activity", action: "1 минута"});
    }, 1 * 60 * 1000);
    window.setTimeout(function () {
        goal_reached({category: "activity", action: "3 минуты"});
    }, 3 * 60 * 1000);
    window.setTimeout(function () {
        goal_reached({category: "activity", action: "5 минут"});
    }, 5 * 60 * 1000);
}
